import { apiInstance } from "shared/api";
import { TransactionsResponse } from "./types";

export const getTransactionsStatusId = (
  id: string,
): Promise<TransactionsResponse> => {
  return apiInstance
    .get(`/v1/transactions/${id}`)
    .then((response) => response.data);
};
